export const MODE = {
    EMAIL: 'EMAIL',
    INTERNAL_NOTE: 'INTERNAL_NOTE',
} as const;
export type Mode = (typeof MODE)[keyof typeof MODE];

export type SendInput = {
    snoozeDuration?: number;
    closeThread?: boolean;
};

export type SenderAddress = {
    address: string;
    display: string;
    isDisabled?: boolean;
};

export type SenderAddressOption = {
    value: string;
    label: string;
    isDisabled?: boolean;
};

export interface PastedImage {
    id: string;
    file: File;
    previewUrl: string;
}

export interface UploadedImage {
    id: string;
    url: string;
}

export interface ImageHandlingProps {
    hasImages: boolean;
    collectAllImageUrls: () => Promise<string[]>;
    clearAllImages: () => void;
}
